import { removeCheckoutSessionId } from '@wix/cashier-common/dist/src/utils/checkoutSessionId';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { createApplePayPayment } from '../../utils/serverAPI/createPayment';
import { type OnPaymentAuthorized } from '../../types/ExternalContract';
import { logGeneralError } from '../../utils/sentry';
import { type AuthParams } from '../../types/AuthParams';
import { longMulti } from '../../utils/bi/constants';
import { type BiLogger } from '../../components/Provider/BiLogger/BiLogger';
import { type BillingContact } from '../../types/BillingContact';
import { type ShippingContact, type ShippingMethod } from '../../types/Shipping';
import { applePayPaymentAuthorized } from '../../utils/bi/events/applePay';
import { getBillingContact, getShippingContact } from './applePayDataMapper';

/**
 * Handles payment authorize event
 */
export const paymentAuthorizeHandler =
  (
    consumerCallback: OnPaymentAuthorized,
    data: {
      shippingMethods: ShippingMethod[];
      appInstanceId: string;
      msid: string;
      currencyCode: string;
      sessionId: string;
    },
    biLogger: BiLogger,
    auth: AuthParams,
  ) =>
  async (event: ApplePayJS.ApplePayPaymentAuthorizedEvent): Promise<ApplePayJS.ApplePayPaymentAuthorizationResult> => {
    try {
      const detailsId = await createApplePayPayment(event.payment.token, auth, data.sessionId);
      const { billingContact, shippingContact } = event.payment;
      const billingContactUnified: BillingContact = getBillingContact(billingContact, shippingContact);
      const shippingContactUnified: ShippingContact = getShippingContact(shippingContact);
      biLogger.report(applePayPaymentAuthorized, {
        checkoutType: 'express',
        amountLong: 1 * longMulti, // we don't have amount here
        appInstanceId: data.appInstanceId,
        currency: data.currencyCode,
        orderSnapshotId: detailsId,
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,

        transactionId: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        amount: undefined as any, // TODO[bi]
      });
      const response = await consumerCallback({
        detailsId,
        shippingContact: shippingContactUnified,
        billingContact: billingContactUnified,
        shippingMethods: data.shippingMethods,
      });
      if (response.result === 'success') {
        removeCheckoutSessionId(data.msid);
        return { status: window.ApplePaySession.STATUS_SUCCESS };
      }
      return { status: window.ApplePaySession.STATUS_FAILURE };
    } catch (e) {
      logGeneralError({
        message: '[ApplePay] paymentAuthorizeHandler failed',
        payload: e,
      });
      return { status: window.ApplePaySession.STATUS_FAILURE };
    }
  };
